var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('o-t-p-keyboard',{attrs:{"title":_vm.$t(_vm.title)},on:{"submit":_vm.checkPinCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }